/**
 * Admin 사이트정보. 라우트 admin.php site.siteinfo 와 동기화.
 */
import { Logger } from "../../utils/Logger";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

const CTRL_TAG = "AdminSiteinfoController";

export const AdminSiteinfoController = {
    edit(): void {
        noop(CTRL_TAG, "edit");
    },
    update(): void {
        noop(CTRL_TAG, "update");
    },
};
